const testimonials = [
  {
    name: 'James Mitchell',
    role: 'Master Electrician, USA',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20electrician%20portrait%20confident%20smiling%20clean%20background%20headshot&width=100&height=100&seq=t1&orientation=squarish',
    quote: 'The ProTech Tool Carrier has completely transformed how I organize my tools on job sites. The build quality is exceptional — I\'ve had mine for 3 years and it still looks brand new.',
  },
  {
    name: 'Sophie Laurent',
    role: 'Field Engineer, France',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20engineer%20portrait%20confident%20smiling%20clean%20background%20headshot&width=100&height=100&seq=t2&orientation=squarish',
    quote: 'I\'ve tried many organizer bags over the years, but Yunxin\'s quality is unmatched. The attention to detail in every pocket and zipper shows true craftsmanship.',
  },
  {
    name: 'Kenji Tanaka',
    role: 'Contractor, Japan',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20male%20contractor%20portrait%20confident%20smiling%20clean%20background%20headshot&width=100&height=100&seq=t3&orientation=squarish',
    quote: 'We\'ve been sourcing from Yunxin for our entire team for 5 years. Consistent quality, reliable delivery, and excellent customer service. Highly recommended for B2B buyers.',
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-24 bg-stone-900">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-3 block">Testimonials</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight">
            Trusted by Professionals<br />Worldwide
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-stone-800 rounded-2xl p-8">
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-amber-400 text-sm" />
                  </div>
                ))}
              </div>
              <p className="text-stone-300 text-sm leading-relaxed mb-6 italic">&ldquo;{t.quote}&rdquo;</p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-stone-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
